import React from 'react';
import { Link } from 'react-router-dom';
import { useEntitlements } from './EntitlementsContext';
import { useJWTAuth } from './auth/JWTAuthContext';
import WalletButton from './WalletButton';

const AppNavigation = ({ menuOpen, setMenuOpen }) => {
  const { hasEntitlement, isAdmin } = useEntitlements();
  const { isAuthenticated } = useJWTAuth();
  const hasThemeCreator = hasEntitlement('theme_creator');
  const showAdminLink = isAdmin();

  //console.log('🧭 [Navigation] Rendering - hasThemeCreator:', hasThemeCreator, 'showAdminLink:', showAdminLink);

  return (
    <>
      {/* Toggle button */}
      <button
        aria-label="Toggle menu"
        onClick={() => setMenuOpen(!menuOpen)}
        className="fixed top-2 right-2 z-50 bg-gray-800 text-white rounded-full w-10 h-10 flex items-center justify-center shadow hover:bg-gray-700"
      >
        {/* Hamburger / Close icon */}
        <span className="text-xl leading-none select-none">{menuOpen ? '×' : '≡'}</span>
      </button>

      {/* Slide-in nav */}
      <nav
        className={`fixed top-0 right-0 h-full w-56 bg-gray-900 text-white shadow-lg transform transition-transform duration-200 z-40 ${menuOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="p-4 border-b border-gray-700 text-lg font-bold">SoulWars</div>
        <div className="flex flex-col p-4 space-y-3">
          <Link to="/" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>Home</Link>
          {isAuthenticated() && (
            <>
              <Link to="/profile" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>Profile</Link>
              <Link to="/account" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>Account</Link>
            </>
          )}
          <Link to="/game" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>Game</Link>
          {isAuthenticated() && (
            <Link to="/heroes" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>Heroes</Link>
          )}
          <Link to="/battlefields" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>Battlefields</Link>
          <Link to="/shop" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>Shop</Link>
          <Link to="/leaderboards" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>Leaderboards</Link>
          {hasThemeCreator && (
            <Link to="/themes" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>Theme Creator</Link>
          )}
          {showAdminLink && (
            <Link to="/admin" className="hover:text-gray-300" onClick={() => setMenuOpen(false)}>Admin</Link>
          )}
          <div className="pt-3 border-t border-gray-700" onClick={(e) => e.stopPropagation()}>
            <WalletButton />
          </div>
        </div>
      </nav>
    </>
  );
};

export default AppNavigation;

